import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowLeft, ArrowRight, Sparkles, ClipboardCheck } from "lucide-react";
import { STEPS } from "@/components/pkg/QuizSteps";
import { BriefSummary } from "@/components/pkg/BriefSummary";
import { EMPTY, toBrief, toCategories, eventTypeLabel, dates } from "@/lib/pkgBrief";

const Progress = ({ step }) => {
  const total = STEPS.length + 1;
  const pct = Math.round(((step + 1) / total) * 100);
  return (
    <div className="mb-8" data-testid="quiz-progress">
      <div className="flex justify-between text-xs font-semibold text-slate-500 mb-2">
        <span data-testid="quiz-progress-label">{step < STEPS.length ? `Domanda ${step + 1} di ${STEPS.length}` : "Riepilogo finale"}</span><span>{pct}%</span>
      </div>
      <div className="h-2 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-gradient-to-r from-[#C98A3C] to-[#E2A453] transition-[width] duration-500 ease-out" style={{ width: `${pct}%` }} data-testid="quiz-progress-bar"/></div>
    </div>
  );
};

export const Questionnaire = ({ onSubmit, busy }) => {
  const [a, setA] = useState(EMPTY);
  const [step, setStep] = useState(0);
  const [back, setBack] = useState(null);
  const set = (patch) => setA((x) => ({ ...x, ...patch }));
  const s = STEPS[step];
  const go = (n) => { setStep(n); setTimeout(() => document.querySelector('[data-testid="pkg-quiz"]')?.scrollIntoView({ behavior: "smooth", block: "start" }), 50); };
  const next = () => { if (back !== null) { setBack(null); go(STEPS.length); } else { go(step + 1); } };
  const preview = () => ({ eventType: eventTypeLabel(a), place: a.place?.name, ...dates(a), brief: toBrief(a) });
  const confirm = () => {
    const categories = toCategories(a);
    if (!categories.length) { toast.error("Indica almeno un artista o un servizio da includere nel pacchetto"); return; }
    const p = preview();
    onSubmit({ place: p.place, date: p.date, dateTo: p.dateTo, eventType: p.eventType, categories, brief: p.brief });
  };
  return (
    <div className="card-premium p-6 sm:p-10 scroll-mt-24" data-testid="pkg-quiz">
      <Progress step={step}/>
      {s ? (
        <div key={s.id} className="animate-in fade-in slide-in-from-right-4 duration-300" data-testid={`quiz-step-${s.id}`}>
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-aic-navy mb-6" data-testid="quiz-question">{s.q}</h2>
          <div className="min-h-[120px]">{s.body(a, set)}</div>
          <div className="flex items-center justify-between gap-3 mt-10 pt-6 border-t border-slate-100">
            <button type="button" disabled={step === 0} onClick={() => go(step - 1)} data-testid="quiz-back" className="btn-pill-outline text-sm disabled:opacity-40"><ArrowLeft className="w-4 h-4"/>Indietro</button>
            <button type="button" disabled={!s.ok(a)} onClick={next} data-testid="quiz-next" className="btn-pill-gold text-sm disabled:opacity-40">{back !== null ? "Torna al riepilogo" : step === STEPS.length - 1 ? "Vai al riepilogo" : "Avanti"}<ArrowRight className="w-4 h-4"/></button>
          </div>
        </div>
      ) : (
        <div className="animate-in fade-in duration-300" data-testid="quiz-summary">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-aic-navy mb-1 flex items-center gap-2"><ClipboardCheck className="w-7 h-7 text-gold"/>Riepilogo della richiesta</h2>
          <p className="text-sm text-slate-500 mb-6">Controlla le risposte: puoi modificarle prima della conferma.</p>
          <BriefSummary p={preview()} onEdit={(i) => { setBack(i); go(i); }}/>
          <div className="flex flex-wrap items-center justify-between gap-3 mt-8 pt-6 border-t border-slate-100">
            <button type="button" onClick={() => go(STEPS.length - 1)} data-testid="quiz-summary-back" className="btn-pill-outline text-sm"><ArrowLeft className="w-4 h-4"/>Indietro</button>
            <button type="button" disabled={busy} onClick={confirm} data-testid="quiz-confirm" className="btn-pill-gold"><Sparkles className="w-4 h-4"/>{busy ? "Composizione…" : "Conferma e genera le proposte"}</button>
          </div>
        </div>
      )}
    </div>
  );
};
